import './footer.css';
import logo from '../assets/images/logo.png'; // usa el logo real luego

function Footer() {
  return (
    <footer className="footer">

      <div className="footer-container">

        {/* IZQUIERDA */}
        <div className="footer-left">
          <img src={logo} alt="Copac" />
        </div>

        {/* CENTRO */}
        <div className="footer-center">
          <p>Kilometro 8 via Cerritos la Virginia
             Sector La Lorena Lote 9 - Pereira (Risaralda)</p>
          <p>📞 +57 302 466 0543</p>
        </div>

        {/* DERECHA (MAPA) */}
        <div className="footer-right">
          <iframe
            src="https://www.google.com/maps?q=Compañía+Papelera+de+Colombia+La+Virginia&output=embed"
            title="mapa"
          />
        </div>

      </div>

      <div className="footer-bottom">
        © COPAC - Todos los derechos reservados
      </div>

    </footer>
  );
}

export default Footer;